import React from 'react';
import { useParams } from 'react-router-dom';
import { ApolloError, useQuery } from '@apollo/client';
import { FindPedagogieByTypeIdQuery } from '../../../graphql/generated/graphql';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import Card from '../../../components/molecules/Card';
import { excerpt } from '../../../helpers/text/excerpt';
import useStyle from './PedagogieRessources.style';
import { QUERY_PEDAGOGIE_BY_TYPE } from '../../../graphql/query/pedagogie/queryPedagogieByType';
import { getPedagogieCardLinks } from '../../../helpers/transformApiResponse/pedagogies';
import { BackButton } from 'components/molecules/Buttons/BackButton';

export const PedagogieRessources = () => {
  const { id } = useParams<{ id: string }>();
  const classes = useStyle();

  const { data, loading, error } = useQuery<FindPedagogieByTypeIdQuery>(
    QUERY_PEDAGOGIE_BY_TYPE,
    {
      variables: { id }
    }
  );

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: error,
            errorMessage: 'error query FindPedagogieByTypeIdQuery'
          })
        }
        text="error query FindPedagogieByTypeIdQuery"
      />
    );

  return (
    <>
      <BackButton text="Retour aux thèmes" />
      <div className={classes.cardContainer}>
        {data.findPedagogieByTypeId.map((pedagogie, index) => {
          const cardLinks = getPedagogieCardLinks(pedagogie);
          return (
            <div className={classes.card} key={index}>
              <Card
                key={index}
                title={pedagogie.name}
                subTitle={pedagogie.subtitle}
                desc={excerpt(pedagogie.desc, 140)}
                links={cardLinks}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
